import Select from "react-select";
import React, { useEffect, useState, useMemo } from "react";

const CitySelector = ({ newData, setNewData, fieldKey, errors, labelStyle = {} }) => {
    const [cities, setCities] = useState([]);
    // console.log("cityerrr:", errors[fieldKey]);

    // Set selected city based on newData.user_related_query
    const selectedCity = useMemo(() => {
        return cities.find(city => city.value === newData[fieldKey]) || null;
    }, [newData, cities, fieldKey]);

    useEffect(() => {
        // Fetch the cities list from JSON file inside public folder
        fetch("/cities.json")
            .then((response) => response.json())
            .then((data) => {
                // Convert cities array into react-select format
                const cityOptions = data.cities.map((city) => ({
                    value: city,
                    label: city,
                }));
                setCities(cityOptions);
            })
            .catch((error) => console.error("Error loading cities:", error));
    }, []);

    const handleCityChange = (selectedOption) => {
        setNewData({ ...newData, [fieldKey]: selectedOption.value }); // ✅ Update form data dynamically
    };

    return (
        <div className="col-12">
            <label className="dropdown-text" style={labelStyle}>
                City/District <span className="red">*</span>
            </label>
            {errors?.[fieldKey] && (
                <p className="error-text">{errors[fieldKey]}</p>
            )}




            <Select
                options={cities}
                value={selectedCity}
                onChange={handleCityChange}
                placeholder={"Search and select a city..."}
                isSearchable
                styles={{
                    control: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                        padding: "2px 10px",
                        borderRadius: "5px",
                        borderColor: "#ccc",
                        background: "#Eff5f9",
                        height: "40px",
                        fontSize: "14px",
                        textAlign: "left", // ✅ Ensures text starts at the left
                    }),
                    input: (base) => ({
                        ...base,
                        margin: "0px",
                        padding: "0px",
                        textAlign: "left", // ✅ Forces cursor to start at the beginning
                        width: "100%",
                    }),
                    placeholder: (base) => ({
                        ...base,
                        display: "flex",
                        alignItems: "center",
                        fontSize: "14px",
                        color: "#888",
                        textAlign: "left",
                    }),
                    option: (base, { isFocused, isSelected }) => ({
                        ...base,
                        backgroundColor: isSelected ? "#00a6ff" : isFocused ? "#f0f0f0" : "#fff",
                        color: isSelected ? "#fff" : "#333",
                        padding: "10px",
                        fontSize: "14px",
                        cursor: "pointer",
                    }),
                }}
            />
        </div>
    );
};

export default CitySelector;
